/** 分享社区接口（与 apps/server/src/routes/community.ts 一一对应） */
import type { Post, PostComment } from '@znjj/shared';
import { apiGet, apiJson } from './client';

export interface PostList {
  list: Post[];
  total: number;
}

export interface PostDetail {
  post: Post;
  comments: PostComment[];
}

export interface PostInput {
  title: string;
  body: string;
  tags: string[];
  deviceIds: string[];
}

export const communityApi = {
  list: (opts: { mine?: boolean } = {}): Promise<PostList> =>
    apiGet<PostList>(`/api/posts${opts.mine ? '?mine=1' : ''}`),

  detail: (id: string): Promise<PostDetail> => apiGet<PostDetail>(`/api/posts/${id}`),

  create: (input: PostInput): Promise<{ post: Post }> => apiJson<{ post: Post }>('POST', '/api/posts', input),

  /** 点赞 / 取消点赞（同一接口切换） */
  like: (id: string): Promise<{ liked: boolean; likeCount: number }> =>
    apiJson<{ liked: boolean; likeCount: number }>('POST', `/api/posts/${id}/like`),

  comments: (id: string): Promise<{ list: PostComment[] }> =>
    apiGet<{ list: PostComment[] }>(`/api/posts/${id}/comments`),

  comment: (id: string, text: string): Promise<{ comment: PostComment }> =>
    apiJson<{ comment: PostComment }>('POST', `/api/posts/${id}/comments`, { text }),
};

/** 社区查询键 */
export const postKeys = {
  list: (mine: boolean) => ['posts', mine ? 'mine' : 'all'] as const,
  detail: (id: string) => ['post', id] as const,
};
